import { render, staticRenderFns } from "./_algoliaSiteList.vue?vue&type=template&id=6859461c"
import script from "./_algoliaSiteList.vue?vue&type=script&lang=js"
export * from "./_algoliaSiteList.vue?vue&type=script&lang=js"
import style0 from "./_algoliaSiteList.vue?vue&type=style&index=0&id=6859461c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports